var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeaturedCardBackgroundDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2238,
    height: 1494,
    viewBox: "0 0 2238 1494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2239,
    height: 1494
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2238 0H0.000976562V1494H2238V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.687 0.245972H2238.67V1557.59H-872.687V0.245972Z",
    fill: "#515258"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -873,
    y: -64,
    width: 3130,
    height: 1559
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2256 -63.15H-872.688V1494.2H2256V-63.15Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.248
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1258,
    y: -2323,
    width: 5988,
    height: 9187
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4729.88 -2322.85H-1257.92V6863.24H4729.88V-2322.85Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.595
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -41,
    y: 480,
    width: 2160,
    height: 2158
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M609.955 1732.04C514.755 1496.14 629.878 1225.22 865.777 1130.01C1101.68 1034.81 1372.61 1149.93 1467.81 1385.84C1563.01 1621.75 1447.87 1892.62 1211.97 1987.82C1157.36 2009.91 1099 2021.26 1040.1 2021.27C856.844 2021.29 682.463 1911.7 609.954 1732.04M634.981 558.114C84.5151 780.272 -184.137 1412.39 38.0202 1962.86C260.177 2513.32 892.305 2781.91 1442.78 2559.76C1993.2 2337.62 2264.72 1712.66 2039.69 1155.04H2039.7C1870.52 735.844 1463.52 480.114 1035.97 480.095C898.534 480.089 762.387 506.582 634.982 558.123",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.408 -502.251L-1107.5 2318.03L1771.19 3764.28L3188.1 944.007L309.408 -502.251Z",
    fill: "#342E52",
    fillOpacity: 0.89
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.595
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -924,
    y: -1711,
    width: 3101,
    height: 2182
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-27.3184 -197.157C-253.794 -305.268 -359.172 -586.926 -251.083 -813.445L-251.091 -813.452C-142.991 -1039.97 145.847 -1148.23 362.309 -1044.39C598.867 -932.016 704.242 -650.342 589.009 -420.933C509.858 -255.066 341.441 -155.693 165.188 -155.691C98.8027 -155.692 33.1781 -169.827 -27.3203 -197.156M-240.742 -1633.93L-252.856 -1629.04C-583.327 -1493.39 -838.203 -1199.08 -903.899 -824.316C-975.609 -404.673 -848.554 -48.5862 -524.199 219.521C-182.661 489.039 193.965 536.552 590.031 385.014V385.021C1136.24 172.89 1419.28 50.3569 1955.47 -166.035C2141.3 -241.035 2220.95 -414.509 2151.71 -586.075C2085.35 -750.496 1907.62 -820.061 1721.79 -745.066L1257.13 -557.546C1254.08 -606.225 1256.82 -640.591 1252.47 -672.046C1227.85 -1227.41 789.851 -1674.12 235.74 -1708.22C210.904 -1709.9 186.069 -1710.73 161.47 -1710.73C23.7515 -1710.76 -112.726 -1684.7 -240.742 -1633.93",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-331.379 -2993.01L-1877.1 83.6541L1576.73 1818.86L3122.44 -1257.8L-331.379 -2993.01Z",
    fill: "#342E52",
    fillOpacity: 0.89
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2238,
    height: 1494,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeaturedCardBackgroundDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FeaturedCardBackgroundDark.645516e932a6d32c3030e996345bf945.svg";